/**
 * DAFinancialsService - Refactorisé pour utiliser le client API centralisé
 */
import apiClient from '../../../services/api';

export default class DAFinancialsService {
    getFinalcialsAnalysisReport = (body) => {
        return apiClient.post("/dataAnalysis/financials", body);
    }
}
